'use client';

import { c as _c } from "react/compiler-runtime";
import { ChevronLeftIcon } from '@heroicons/react/24/outline';
import { Button } from '@src/components/Button/Button';
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink';
import { useTopNav } from '@src/components/TopNavV4/TopNavContext';
import { TopNavSubMenuTileSlider } from '@src/components/TopNavV4/TopNavMobile/TopNavSubMenuTileSlider';
import type { TopNavSubItem } from '@src/components/TopNavV4/TopNavProps';
import { useTrackSelectNavCta } from '@src/utils/analytics.util';
import { cn } from '@src/utils/tailwind';
export const TopNavMobileSubMenu = () => {
  const $ = _c(38);
  const trackSelectNavCta = useTrackSelectNavCta();
  const {
    expandedMenu,
    setMobileSubExpanded,
    setExpanded
  } = useTopNav();
  let t0;
  if ($[0] !== expandedMenu?.title || $[1] !== setMobileSubExpanded) {
    t0 = () => <div className="flex h-14 items-center border-b border-white/10 p-4"><button onClick={() => {
        setMobileSubExpanded(false);
      }} className="flex items-center gap-2"><ChevronLeftIcon className="size-5 text-bodi-accent-bright-500" /><p className="text-heading-4 text-left font-lateral">{expandedMenu?.title}</p></button></div>;
    $[0] = expandedMenu?.title;
    $[1] = setMobileSubExpanded;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const renderTitle = t0;
  let t1;
  if ($[3] !== expandedMenu?.ctaMobile?.href || $[4] !== expandedMenu?.ctaMobile?.newTab || $[5] !== expandedMenu?.ctaMobile?.title || $[6] !== expandedMenu?.hasCtaMobile || $[7] !== setExpanded || $[8] !== trackSelectNavCta) {
    t1 = () => {
      const content = <Button className="w-full" size="medium">{expandedMenu?.ctaMobile?.title}</Button>;
      return expandedMenu?.hasCtaMobile && expandedMenu?.ctaMobile?.title && <><div className="h-[170px]" /><div className="fixed bottom-0 left-0 h-[85px] w-screen border-t border-bodi-gray-dark bg-bodi-black-text px-4 py-5"><div className="font-medium text-bodi-accent-bright-500">{expandedMenu?.ctaMobile?.href ? <LocalizedLink data-testid="menu-featured-item-mobile" onClick={() => {
              trackSelectNavCta({
                "cta url": expandedMenu?.ctaMobile?.href
              });
              setExpanded(false);
            }} href={expandedMenu?.ctaMobile?.href ?? ""} rel={expandedMenu?.ctaMobile?.newTab ? "noopener noreferrer" : ""} target={expandedMenu?.ctaMobile?.newTab ? "_blank" : "_self"}>{content}</LocalizedLink> : <div>{content}</div>}</div></div></>;
    };
    $[3] = expandedMenu?.ctaMobile?.href;
    $[4] = expandedMenu?.ctaMobile?.newTab;
    $[5] = expandedMenu?.ctaMobile?.title;
    $[6] = expandedMenu?.hasCtaMobile;
    $[7] = setExpanded;
    $[8] = trackSelectNavCta;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const renderCtaMobile = t1;
  let t2;
  if ($[10] !== setExpanded || $[11] !== setMobileSubExpanded || $[12] !== trackSelectNavCta) {
    t2 = (item, itemIdx) => <div key={item.title} className={cn("border-t border-white/10 px-4 py-6", {
      "border-t-0": itemIdx === 0
    })}><div className="mb-2 text-body-md font-medium">{item.href ? <LocalizedLink className="inline-block hover:underline" data-testid={`sub-menu-${itemIdx}`} onClick={() => {
          trackSelectNavCta({
            "cta url": item?.href
          });
          setExpanded(false);
          setMobileSubExpanded(false);
        }} href={item?.href} key={item?.title} rel={item?.newTab ? "noopener noreferrer" : ""} target={item?.newTab ? "_blank" : "_self"}>{item.title}</LocalizedLink> : <div>{item.title}</div>}</div><div className="flex flex-col gap-3">{item.links?.filter(_temp).map((subItem_0, subItemIdx) => <LocalizedLink className="flex w-fit items-center gap-1 text-body-sm font-medium text-bodi-gray-butters hover:underline" data-testid={`sub-menu-${subItemIdx}`} onClick={() => {
          trackSelectNavCta({
            "cta url": subItem_0?.href
          });
          setExpanded(false);
          setMobileSubExpanded(false);
        }} href={subItem_0?.href ?? ""} key={subItem_0?.title} rel={subItem_0?.newTab ? "noopener noreferrer" : ""} target={subItem_0?.newTab ? "_blank" : "_self"}><div>{subItem_0.title}</div>{subItem_0.stamp && <>{"-"}<span className="text-body-sm font-medium text-bodi-accent-bright-500">{subItem_0.stamp}</span></>}</LocalizedLink>)}</div></div>;
    $[10] = setExpanded;
    $[11] = setMobileSubExpanded;
    $[12] = trackSelectNavCta;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  const renderSubItem = t2;
  let t3;
  if ($[14] !== setExpanded || $[15] !== setMobileSubExpanded || $[16] !== trackSelectNavCta) {
    t3 = (item_0, itemIdx_0) => <LocalizedLink className="text-body-sm font-medium text-bodi-gray-butters hover:underline" data-testid={`sub-menu-${itemIdx_0}`} onClick={() => {
      trackSelectNavCta({
        "cta url": item_0?.href
      });
      setExpanded(false);
      setMobileSubExpanded(false);
    }} href={item_0?.href ?? ""} key={item_0?.title} rel={item_0?.newTab ? "noopener noreferrer" : ""} target={item_0?.newTab ? "_blank" : "_self"} dangerouslySetInnerHTML={{
      __html: item_0.title ?? ""
    }} />;
    $[14] = setExpanded;
    $[15] = setMobileSubExpanded;
    $[16] = trackSelectNavCta;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  const renderMiniMenuSubItem = t3;
  let t4;
  if ($[18] !== renderTitle) {
    t4 = renderTitle();
    $[18] = renderTitle;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  let t5;
  if ($[20] !== expandedMenu?.subItems || $[21] !== renderSubItem) {
    t5 = expandedMenu?.subItems?.filter(_temp2).map((item_2, itemIdx_1) => renderSubItem(item_2, itemIdx_1));
    $[20] = expandedMenu?.subItems;
    $[21] = renderSubItem;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  let t6;
  if ($[23] !== expandedMenu?.miniMenuSubItems || $[24] !== renderMiniMenuSubItem) {
    t6 = expandedMenu?.miniMenuSubItems?.filter(_temp3).map((item_4, itemIdx_2) => renderMiniMenuSubItem(item_4, itemIdx_2));
    $[23] = expandedMenu?.miniMenuSubItems;
    $[24] = renderMiniMenuSubItem;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  let t7;
  if ($[26] !== t6) {
    t7 = <div className="flex flex-col gap-3 px-4 py-6">{t6}</div>;
    $[26] = t6;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  let t8;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <TopNavSubMenuTileSlider />;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== t5 || $[30] !== t7) {
    t9 = <div className="relative flex flex-col">{t5}{t7}{t8}</div>;
    $[29] = t5;
    $[30] = t7;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  let t10;
  if ($[32] !== renderCtaMobile) {
    t10 = renderCtaMobile();
    $[32] = renderCtaMobile;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  let t11;
  if ($[34] !== t10 || $[35] !== t4 || $[36] !== t9) {
    t11 = <div className="relative">{t4}{t9}{t10}</div>;
    $[34] = t10;
    $[35] = t4;
    $[36] = t9;
    $[37] = t11;
  } else {
    t11 = $[37];
  }
  return t11;
};
function _temp(subItem) {
  return Boolean(subItem.title);
}
function _temp2(item_1) {
  return Boolean(item_1.title);
}
function _temp3(item_3) {
  return Boolean(item_3.title);
}